import { validators } from "@shopify/react-form-state";
import { SurveyLimits } from "@teams/cards";
import { NominalQuestion } from "@teams/types";

import { executeValidators } from "./surveyValidators";
import { validateList } from "./validateList";
import { ListValidatorDictionary } from ".";

export function getQuestionValidator(): Partial<ListValidatorDictionary<NominalQuestion, unknown>> {
  return {
    label: [
      validators.required("Question title is required"),
      validators.lengthMoreThan(
        SurveyLimits.Questions.Label.MinLength - 1,
        `Question title must be at least ${SurveyLimits.Questions.Label.MinLength} characters`
      ),
      validators.lengthLessThan(
        SurveyLimits.Questions.Label.MaxLength,
        `Question title must be shorter than ${SurveyLimits.Questions.Label.MaxLength} characters`
      ),
      // tslint:disable-next-line: no-any
    ] as any,

    choices: validateList({
      value: input => {
        const error = executeValidators(String(input), [
          validators.required("Choice is required"),
          validators.lengthMoreThan(
            SurveyLimits.Questions.Choices.Value.MinLength - 1,
            `Choice length must be at least ${SurveyLimits.Questions.Choices.Value.MinLength} characters`
          ),
          validators.lengthLessThan(
            SurveyLimits.Questions.Choices.Value.MaxLength,
            `Choice length must be less than ${SurveyLimits.Questions.Choices.Value.MaxLength} characters`
          ),
        ]);
        if (error) {
          return error;
        }
      },
      label: input => {
        const error = executeValidators(String(input), [
          validators.required("Choice label is required"),
          validators.lengthMoreThan(
            SurveyLimits.Questions.Choices.Value.MinLength - 1,
            `Choice label length must be at least ${SurveyLimits.Questions.Choices.Label.MinLength} characters`
          ),
          validators.lengthLessThan(
            SurveyLimits.Questions.Choices.Value.MaxLength,
            `Choice label length must be less than ${SurveyLimits.Questions.Choices.Label.MaxLength} characters`
          ),
        ]);
        if (error) {
          return error;
        }
      },
    }),
  };
}
